export const Separator = () => (
    <div className="separator"></div>
);